module.exports = __webpack_public_path__ + "media/assets/images/flags/br-45fa446b95f26b8591dc7966efbe0b75.svg";